"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePresenterAddedToChimeSLI = void 0;
var _react = require("react");
var _useCommonPageActionsApi = require("../../client/react/useCommonPageActionsApi");
var _logger = require("@studio/logger");
/**
 * Handles the presenter joining the SLI ending
 *
 * @param {*} presenterAddedSLIStartedRef - Flag to know if start SLI function was called
 * @param {*} notificationMessage - The string may contain an error message in case of failure
 * @param {*} presenterAddedToChimeSLICallback - SLI ending Function to be called when the knock approval process has ended
 * @param {*} sourceList - Array of source list
 * @param {*} presenterSessionIdRef - The external user ID of the presenter
 */
var handlePresenterJoinSLI = function handlePresenterJoinSLI(presenterAddedSLIStartedRef, failureMessage, presenterAddedToChimeSLICallback, sourceList, presenterSessionIdRef) {
  if (failureMessage) {
    presenterAddedToChimeSLICallback({
      error: "Error while creating meeting for presenter: ".concat(failureMessage)
    });
    presenterAddedSLIStartedRef.current = false;
    presenterSessionIdRef.current = '';
  } else {
    var filteredSource = sourceList.some(function (s) {
      return s.presenterSessionId === presenterSessionIdRef.current;
    });
    (0, _logger.sendToDatadog)('presenterJoinChimeSLIHelper', {}, "Filtered source boolean value for presenter join SLI for presenterSessionId: ".concat(presenterSessionIdRef.current, " is ").concat(filteredSource));
    if (filteredSource) {
      presenterAddedToChimeSLICallback({});
      presenterAddedSLIStartedRef.current = false;
      presenterSessionIdRef.current = '';
    }
  }
};

/**
 * Custom hook to manage the state of presenter added to Chime SLI.
 *
 * @returns {Object} An object containing the following properties:
 * - startPresenterAddedToChimeSLI: Function to start the presenter added to Chime SLI.
 * - endPresenterAddedToChimeSLI: Function to end the presenter added to Chime SLI.
 */
var usePresenterAddedToChimeSLI = exports.usePresenterAddedToChimeSLI = function usePresenterAddedToChimeSLI() {
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    startPresenterAddedToChimeMeeting = _useCommonPageActions.startPresenterAddedToChimeMeeting,
    endPresenterAddedToChimeMeeting = _useCommonPageActions.endPresenterAddedToChimeMeeting;
  var presenterAddedSLIStartedRef = (0, _react.useRef)(false);
  var presenterSessionIdRef = (0, _react.useRef)('');

  /**
   * Starts the presenter added to Chime SLI.
   *
   * @param {string} presenterId - The ID of the presenter.
   * @param {string} presenterName - The name of the presenter.
   * @param {string} presenterSessionId - The session ID of the presenter.
   * @param {string} pathName - The name of the path.
   * @param {string} pathURL - The URL of the path.
   */
  var startPresenterAddedToChimeSLI = (0, _react.useCallback)(function (presenterId, presenterName, presenterSessionId, pathName, pathURL) {
    presenterAddedSLIStartedRef.current = true;
    startPresenterAddedToChimeMeeting({
      presenterName: presenterName,
      pathName: pathName,
      url: pathURL
    });
    presenterSessionIdRef.current = "Presenter-".concat(presenterId, "-").concat(presenterSessionId);
  }, [startPresenterAddedToChimeMeeting]);

  /**
   * Ends the presenter added to Chime SLI.
   *
   * @param {Array} sources - Existing sources array
   * @param {string} notificationMessage - The string may contain an error message in case of failure
   */
  var endPresenterAddedToChimeSLI = (0, _react.useCallback)(function (sources, failureMessage) {
    if (presenterAddedSLIStartedRef.current) {
      handlePresenterJoinSLI(presenterAddedSLIStartedRef, failureMessage, endPresenterAddedToChimeMeeting, sources, presenterSessionIdRef);
    }
  }, [endPresenterAddedToChimeMeeting]);
  return (0, _react.useMemo)(function () {
    return {
      startPresenterAddedToChimeSLI: startPresenterAddedToChimeSLI,
      endPresenterAddedToChimeSLI: endPresenterAddedToChimeSLI
    };
  }, [startPresenterAddedToChimeSLI, endPresenterAddedToChimeSLI]);
};